(function () {

    'use strict';

    angular.module('asys')
        .service('AngebotModel', AngebotModel);

    AngebotModel.$inject = [
        '$log',
        '$rootScope',
        '$http',
        '$q',
        '$injector',
        'lodash',
        'moment',
        'AppConfig',
        'IntegrationService',
        'FormatUtilsService',
        'MiscUtilsService',
        '$analytics'
    ];
    function AngebotModel($log, $rootScope, $http, $q, $injector, _, moment, AppConfig, IntegrationService, FormatUtilsService, MiscUtilsService, $analytics) {
        var that = this,
            angebotModel = {
                angebot: null,
                angebotLetzteBerechnung: null,
                angebotLetzteSpeicherung: null,
                angebotLetzterDruck: null,
                formData: null,
                tarif: null
            },
            angebotDefaults,
            paramsDummyAngebotModel,
            lastSavedAngebotDefaults;

        that.init = init;
        that.initAngebotModel = initAngebotModel;
        that.initAngebotInitial = initAngebotInitial;
        that.initAngebotOriginal = initAngebotOriginal;

        that.getTarifgeneration = getTarifgeneration;
        that.getAngebotNeu = getAngebotNeu;
        that.getTarifgenerationUndAngebotNeu = getTarifgenerationUndAngebotNeu;
        that.getAngebot = getAngebot;

        that.ladeAngebotOderErstelleDummyAngebotModel = ladeAngebotOderErstelleDummyAngebotModel;
        that.erstelleNeuesAngebot = erstelleNeuesAngebot;
        that.ladeAngebot = ladeAngebot;
        that.pruefeAngebotVorStart = pruefeAngebotVorStart;
        that.preCheck = preCheck;
        that.angebotVorbelegen = angebotVorbelegen;
        that.getLastSavedAngebotDefaults = getLastSavedAngebotDefaults;

        that.get = get;
        that.setTarif = setTarif;
        that.clear = clear;
        $rootScope.$on('iplusjs:asysAngebotDefaults', function (event, message) {
            $log.log('iplusjs:asysAngebotDefaults', message, event);
            angebotVorbelegen(_.get(message, 'defaults'));
        });
        function init(angebot, isDummyModel) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                tarifauskunftsdatum;

            isDummyModel = isDummyModel || false;

            if (!angebot) {
                isDummyModel = true;
            }

            angebot = angebot || {};
            angebot.angebotstyp = AppConfig.ANGEBOT.angebotstyp || angebot.angebotstyp;

            if (isDummyModel) {
                tarifauskunftsdatum = BasisAngebotService.getTarifauskunftsdatum(angebot);
            }

            if (angebotModel.orderId) {
                MiscUtilsService.setDefaultValueIfEmpty(angebot, 'orderId', angebotModel.orderId);
            }

            angebotModel.isDummyModel = isDummyModel;

            initAngebotModel(angebot);
            initAngebotInitial(angebot);
            initAngebotOriginal(angebot);

            angebotModel.wurdeGeladen = false;

            if (isDummyModel) {
                _.set(angebotModel, 'tarif.tarifkuerzel', AppConfig.ANGEBOT.tarifkuerzel);
                BasisAngebotService.setTarifauskunftsdatum(angebot, tarifauskunftsdatum);
            }

            return angebotModel;
        }
        function initAngebotModel(angebot) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                AngebotSpezifischModel = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Model'),
                integrationParameters = IntegrationService.getIntegrationParams();

            angebotModel.angebot = _.cloneDeep(angebot);
            MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'tarif.tarifkuerzel', AppConfig.ANGEBOT.tarifkuerzel);
            angebotDefaults = _.merge({}, integrationParameters.mappings, integrationParameters.angbestandteileAktiv, getLastSavedAngebotDefaults());

            if (!angebotModel.isDummyModel) {
                BasisAngebotService.setDefaults(angebotModel.angebot);
            }
            $log.log('initAngebotModel angebotDefaults', angebotDefaults);

            if (MiscUtilsService.isNotEmpty(angebotDefaults)) {
                angebotVorbelegen(angebotDefaults);
            }

            angebotModel.formData = {
                allgemeineDaten: {},
                antragsteller: {},
                zahlungsinformationen: {},
                vorschaeden: {}
            };

            if (_.isFunction(AngebotSpezifischModel.initAngebotModel)) {
                AngebotSpezifischModel.initAngebotModel(angebotModel);
            }

            BasisAngebotService.mapServiceToFormData(angebotModel.angebot, angebotModel.formData);

            if (!BasisAngebotService.isAngebotAenderbar(angebotModel.angebot, 'ANGEBOT')) {
                angebotModel.angebotLetzteBerechnung = _.cloneDeep(angebotModel.angebot);
            } else if (BasisAngebotService.beitraegeVorhanden(angebotModel.angebot)) {
                angebotModel.angebotLetzteBerechnung = _.cloneDeep(angebotModel.angebot);
            } else {
                angebotModel.angebotLetzteBerechnung = null;
            }

            if (BasisAngebotService.getAngebotsnummer(angebotModel.angebot)) {
                angebotModel.angebotLetzteSpeicherung = _.cloneDeep(angebotModel.angebot);
            } else {
                angebotModel.angebotLetzteSpeicherung = null;
            }

            angebotModel.angebotLetzterRefresh = _.cloneDeep(angebotModel.angebot);
            angebotModel.angebotLetzterDruck = null;
        }
        function initAngebotInitial(angebotInitial) {
            var BasisAngebotService = $injector.get('BasisAngebotService');

            angebotModel.angebotInitial = _.cloneDeep(angebotInitial);
            BasisAngebotService.setDefaults(angebotModel.angebotInitial);
        }
        function initAngebotOriginal(angebotOriginal) {
            angebotModel.angebotOriginal = _.cloneDeep(angebotOriginal);
        }
        function getTarifgeneration(tarifauskunftsdatum) {
            var BasisAngebotService = $injector.get('BasisAngebotService');

            tarifauskunftsdatum = tarifauskunftsdatum || BasisAngebotService.getDefaultTarifauskunftsdatum();

            return $http({
                method: 'GET',
                url: AppConfig.API.services.angTarifgeneration,
                params: {
                    angebotsdatum: tarifauskunftsdatum
                }
            }).then(function (response) {
                response = response || {};

                angebotModel.tarif = response.data;
                return response.data;
            });
        }
        function getAngebotNeu(tarifauskunftsdatum, tarifkuerzel, params) {
            var integrationParameters = IntegrationService.getIntegrationParams(),
                pathParameters = [],
                parameter = {
                    angebotsdatum: tarifauskunftsdatum
                };

            params = params || {};
            params.pathParameters = params.pathParameters || {};
            params.queryParameters = params.queryParameters || {};

            pathParameters.push(integrationParameters.angwkz);
            pathParameters.push(params.pathParameters.gevo);

            parameter = _.merge(parameter, params.queryParameters, integrationParameters.queryParameters);

            return $http({
                method: 'GET',
                url: FormatUtilsService.replace.apply(null, _.flatten([AppConfig.API.services.angNeu, tarifkuerzel, pathParameters])),
                params: parameter,
                showErrorPage: true
            }).then(function (response) {
                response = response || {};

                

                return response.data;
            });
        }
        function getTarifgenerationUndAngebotNeu(tarifauskunftsdatum, params) {
            return $q(function (resolve, reject) {
                getTarifgeneration(tarifauskunftsdatum).then(function (data) {
                    getAngebotNeu(tarifauskunftsdatum, data.tarifkuerzel, params).then(function (data) {
                        resolve(data);
                    }).catch(function (error) {
                        reject(error);
                    });
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
        function getAngebot(angebotsnummer, angebotstoken) {
            return $q(function (resolve, reject) {
                var serviceUrl;

                if (angebotsnummer && angebotstoken) {
                    serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angGetAngTgWithToken, angebotsnummer, angebotstoken);
                } else if (angebotsnummer) {
                    serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angGetAngTg, angebotsnummer);
                }

                $http({
                    method: 'GET',
                    url: serviceUrl
                }).then(function (response) {
                    response = response || {};

                    resolve(response.data);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
        function getNeuesAngebot(tarifauskunftsdatum, tarif, params) {
            return $q(function (resolve, reject) {
                if (!_.get(tarif, 'tarifkuerzel') && AppConfig.ANGEBOT.disableTarifgenerationHandling === true) {
                    tarif = {
                        tarifkuerzel: AppConfig.ANGEBOT.tarifkuerzel
                    };
                }

                if (!tarif || !tarif.tarifkuerzel) {
                    getTarifgenerationUndAngebotNeu(tarifauskunftsdatum, params).then(function (angebot) {
                        resolve(angebot);
                    }).catch(function (error) {
                        reject(error);
                    });
                } else {
                    getAngebotNeu(tarifauskunftsdatum, tarif.tarifkuerzel, params).then(function (angebot) {
                        resolve(angebot);
                    }).catch(function (error) {
                        reject(error);
                    });
                }
            });
        }
        function ladeAngebotOderErstelleDummyAngebotModel(tarifauskunftsdatum, tarif, options, params) {
            var integrationParams = IntegrationService.getIntegrationParams(),
                BasisAngebotService = $injector.get('BasisAngebotService'),
                stichtagTarif;

            tarifauskunftsdatum = tarifauskunftsdatum || integrationParams.tarifauskunftsdatum;
            stichtagTarif = _.get(params, 'stichtagTarif') || _.get(integrationParams, 'stichtagTarif');

            options = options || {};

            options.erzeugeNeuesAngebotImFehlerfall = options.erzeugeNeuesAngebotImFehlerfall !== false;

            if (integrationParams.angnummer) {
                return $q(function (resolve, reject) {
                    $analytics.eventTrack('link', {
                        target: 'Angebot-laden'
                    });

                    ladeAngebot(integrationParams.angnummer, integrationParams.angtoken).then(function (angebotModel) {
                        resolve(angebotModel);
                    }).catch(function (error) {
                        if (options.erzeugeNeuesAngebotImFehlerfall) {
                            IntegrationService.setIntegrationParams({ angnummer: null });

                            ladeAngebotOderErstelleDummyAngebotModel.call(null, tarifauskunftsdatum, tarif, options, params).then(function (data) {
                                resolve(data);
                            }).catch(function (error) {
                                reject(error);
                            });
                        } else {
                            reject(error);
                        }
                    });
                });
            } else {
                return $q(function (resolve, reject) {
                    paramsDummyAngebotModel = {
                        tarifauskunftsdatum: tarifauskunftsdatum,
                        params: params
                    };

                    var initAngebot = {
                        stichtagTarif: stichtagTarif
                    };

                    _.set(initAngebot, BasisAngebotService.getTarifauskunftsdatumPath(), tarifauskunftsdatum);

                    if (integrationParams.angmodus !== 'ersatz') {
                        pruefeAngebotVorStart().catch(function (error) {
                            reject(error);
                        }).finally(function () {
                            resolve(init(initAngebot, true));
                        });
                    } else {
                        resolve(init(initAngebot, true));
                    }
                });
            }
        }
        function erstelleNeuesAngebot(tarifauskunftsdatum, tarif, params) {
            if (paramsDummyAngebotModel) {
                params = _.merge({}, params, paramsDummyAngebotModel.params);
                tarifauskunftsdatum = tarifauskunftsdatum || paramsDummyAngebotModel.tarifauskunftsdatum;
                paramsDummyAngebotModel = {};
            }

            return getNeuesAngebot(tarifauskunftsdatum, tarif, params).then(function (angebot) {
                if (!angebot || !_.isObject(angebot)) {
                    return $q.reject();
                }

                init(angebot);
                return angebotModel;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function ladeAngebot(angebotsnummer, angebotstoken) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                versicherungsbeginnAnpassungNotwendigMessage,
                beitragsanpassungWechselAutomatischMessage,
                beitragsanpassungWechselMoeglichMessage;

            return getAngebot(angebotsnummer, angebotstoken).then(function (angTg) {
                if (!angTg || !_.isObject(angTg)) {
                    return $q.reject();
                }

                if (MiscUtilsService.isEmpty(angTg.tarifgeneration)) {
                    _.set(angebotModel, 'tarif.tarifkuerzel', AppConfig.ANGEBOT.tarifkuerzel);
                } else {
                    angebotModel.tarif = angTg.tarifgeneration;
                }

                angebotModel.wurdeGeladen = true;
                initAngebotModel(angTg.angebot);
                initAngebotInitial(angTg.angebotInitial || angTg.angebot);
                initAngebotOriginal(angTg.angebot);

                versicherungsbeginnAnpassungNotwendigMessage = _.find(angTg.messages, ['reason', 'VERSICHERUNGSBEGINN_ANPASSUNG_NOTWENDIG']);
                beitragsanpassungWechselAutomatischMessage = _.find(angTg.messages, ['reason', 'BEITRAGSANPASSUNG_WECHSEL_AUTOMATISCH_DURCHGEFUEHRT']);
                beitragsanpassungWechselMoeglichMessage = _.find(angTg.messages, ['reason', 'BEITRAGSANPASSUNG_WECHSEL_MOEGLICH']);

                if (versicherungsbeginnAnpassungNotwendigMessage) {
                    BasisAngebotService.resetBeitraege(angebotModel.angebot);
                    $rootScope.$emit('iplusjs:createAndAddAlert', {
                        type: versicherungsbeginnAnpassungNotwendigMessage.cause,
                        message: versicherungsbeginnAnpassungNotwendigMessage.message,
                        id: versicherungsbeginnAnpassungNotwendigMessage.reason
                    });
                }

                if (beitragsanpassungWechselAutomatischMessage) {
                    $rootScope.$emit('iplusjs:createAndAddAlert', {
                        type: beitragsanpassungWechselAutomatischMessage.cause,
                        message: beitragsanpassungWechselAutomatischMessage.message,
                        id: beitragsanpassungWechselAutomatischMessage.reason
                    });

                    BasisAngebotService.setBeitragsanpassungMessage(beitragsanpassungWechselAutomatischMessage);
                }

                if (beitragsanpassungWechselMoeglichMessage) {
                    BasisAngebotService.resetBeitraege(angebotModel.angebot);

                    BasisAngebotService.setBeitragsanpassungMessage(beitragsanpassungWechselMoeglichMessage);
                }

                return angebotModel;
            });
        }
        function pruefeAngebotVorStart(tarifauskunftsdatum) {
            return $q(function (resolve, reject) {
                return preCheck().then(function () {
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
        function preCheck(tarifkuerzel) {
            tarifkuerzel = tarifkuerzel || AppConfig.ANGEBOT.tarifkuerzel;

            var serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angPreCheck, tarifkuerzel);

            if (MiscUtilsService.isAtLeastOneEmpty(serviceUrl, tarifkuerzel)) {
                return $q.resolve();
            }

            return $http({
                method: 'GET',
                url: serviceUrl,
                showErrorPage: true
            }).then(function (response) {
                response = response || {};

                return response.data;
            });
        }
        function get() {
            return angebotModel || {};
        }
        function angebotVorbelegen(defaults, reset) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                IdentityTypeUtilsService = $injector.get('IdentityTypeUtilsService'),
                AngebotSpezifischModel;

            lastSavedAngebotDefaults = _.cloneDeep(defaults);

            $log.log('angebotVorbelegen begin', angebotModel, lastSavedAngebotDefaults, reset);

            if (!angebotModel || !angebotModel.angebot) {
                angebotDefaults = defaults;
            } else {
                angebotDefaults = null;
                AngebotSpezifischModel = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebotModel.angebot) + 'Model');

                $rootScope.$applyAsync(function () {
                    _.forOwn(defaults, function (obj, key) {
                        var foundValue;

                        $log.log('angebotVorbelegen loop', obj, key);

                        if (obj && obj.type === 'array') {
                            foundValue = _.find(_.get(angebotModel.angebot, key), [obj.findProp, _.get(obj.value, obj.findProp)]);

                            if (foundValue) {
                                _.merge(foundValue, obj.value);
                            } else {
                                if (_.isArray(_.get(angebotModel.angebot, key))) {
                                    _.get(angebotModel.angebot, key).push(obj.value);
                                } else {
                                    _.set(angebotModel.angebot, key, [].push(obj.value));
                                }
                            }
                        } else {
                            if (_.has(obj, 'value')) {
                                _.set(angebotModel.angebot, key, obj.value);
                            } else if (!IdentityTypeUtilsService.isIdentityType(obj) || (IdentityTypeUtilsService.isIdentityType(obj) && IdentityTypeUtilsService.isValid(obj))) {
                                _.set(angebotModel.angebot, key, obj);
                            }
                        }
                    });

                    if (_.get(_.get(defaults, 'antragsteller.imOeffentlichemDienstTaetig'), 'value')) {
                        _.set(angebotModel.angebot, 'antragsteller.arbeitgeber', {
                            wert: '1',
                            typ: 'ARBEITGEBER'
                        });
                    }

                    if (angular.isFunction(AngebotSpezifischModel.angebotVorbelegen)) {
                        AngebotSpezifischModel.angebotVorbelegen(angebotModel, defaults);
                    }

                    BasisAngebotService.mapServiceToFormData(angebotModel.angebot, angebotModel.formData);

                    $log.log('angebotVorbelegen end', angebotModel.angebot);

                    lastSavedAngebotDefaults = reset ? null : lastSavedAngebotDefaults;
                });
            }
        }
        function getLastSavedAngebotDefaults() {
            return lastSavedAngebotDefaults;
        }
        function setTarif(tarif) {
            angebotModel.tarif = tarif;
        }
        function clear() {
            angebotModel.angebot = null;
            angebotModel.angebotOriginal = null;
            angebotModel.angebotInitial = null;
            angebotModel.wurdeGeladen = false;
            angebotModel.wurdeKopiert = false;
            angebotModel.angebotLetzteBerechnung = null;
            angebotModel.angebotLetzteSpeicherung = null;
            angebotModel.angebotLetzterRefresh = null;
            angebotModel.angebotLetzterDruck = null;
            angebotModel.formData = null;
            angebotModel.angebotSondereinstufungen = null;
            angebotModel.isDummyModel = null;
            angebotModel.tarif = null;
            angebotModel.plausis = null;
        }
    }

})();
